export var borderRadius = function (value) { return ({
    borderTopRightRadius: value,
    borderTopLeftRadius: value,
    borderBottomRightRadius: value,
    borderBottomLeftRadius: value,
}); };
export var borderWidth = function (value) { return ({
    borderTopWidth: value,
    borderRightWidth: value,
    borderBottomWidth: value,
    borderLeftWidth: value,
}); };
export var borderStyle = function (value) { return ({
    borderTopStyle: value,
    borderBottomStyle: value,
    borderRightStyle: value,
    borderLeftStyle: value,
}); };
export var borderColor = function (value) { return ({
    borderTopColor: value,
    borderRightColor: value,
    borderBottomColor: value,
    borderLeftColor: value,
}); };
export var padding = function (value) { return ({
    paddingTop: value,
    paddingRight: value,
    paddingBottom: value,
    paddingLeft: value,
}); };
export var margin = function (value) { return ({
    marginTop: value,
    marginRight: value,
    marginBottom: value,
    marginLeft: value,
}); };
